import { render, staticRenderFns } from "./Translations.vue?vue&type=template&id=122b1848&"
import script from "./Translations.vue?vue&type=script&lang=js&"
export * from "./Translations.vue?vue&type=script&lang=js&"
import style0 from "./Translations.vue?vue&type=style&index=0&id=122b1848&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports